import { Button } from "react-bootstrap";

function ConfirmDelete({ resourceName, onConfirm, disabled, onCloseModal }) {
  return (
    <div className="styled-small-popup">
      <h3>Delete {resourceName}</h3>

      <p>Are you sure you want to delete this item permanently? This action cannot be undone.</p>

      <div>
        <Button variant="outline-dark" disabled={disabled} onClick={onCloseModal}>
          Cancel
        </Button>
        <Button variant="danger" disabled={disabled} onClick={onConfirm}>
          Delete
        </Button>
      </div>
    </div>
  );
}

export default ConfirmDelete;
